/** NPAS-only matching normalization; preserve the user's input and answer text. */
const PORTUGUESE_ABBREVIATIONS: Readonly<Record<string, string>> = {
  vc: 'voce',
  vcs: 'voces',
  pq: 'por que',
  q: 'que',
  tb: 'tambem',
  tbm: 'tambem',
  pfv: 'por favor',
  obg: 'obrigado',
  obgd: 'obrigado',
  eh: 'e',
  qdo: 'quando',
  qto: 'quanto',
  qtos: 'quantos',
  qta: 'quanta',
  qtas: 'quantas',
  pra: 'para',
  pro: 'para o',
  pras: 'para as',
  pros: 'para os',
};

export function normalizeQueryForMatching(text: string, clientId: string): string {
  if (clientId !== 'npas') return text;
  return text
    .toLowerCase()
    .normalize('NFD')
    .replace(/\p{M}/gu, '')
    .replace(/\b\w+\b/g, (word) =>
      Object.hasOwn(PORTUGUESE_ABBREVIATIONS, word) ? PORTUGUESE_ABBREVIATIONS[word] : word,
    )
    .replace(/\s+/g, ' ')
    .trim();
}
